var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import useCheckboxes from "../../Hooks/useCheckboxes";
import usePagedSortedTable, { TotalPageMappers, } from "../../Hooks/usePagedSortedTable";
import { SearchButton } from "../../UI/StandardButtons/StandardButtons";
import { AlertError } from "../../UI/StandardAlerts/StandardAlerts";
import LmsIntegrationService from "../../../Services/LmsIntegration.service";
const PAGE_SIZE = 20;
const SEARCH_DEFAULT = "";
const DEFAULT_SEARCH = {
    query: SEARCH_DEFAULT,
};
const LmsIntegrationLookup = ({ selected: selectedLmsIntegrations, children, }) => {
    var _a;
    const [query, setQuery] = React.useState(SEARCH_DEFAULT);
    const [searchArgs, setSearchArgs] = React.useState(DEFAULT_SEARCH);
    const [validationError, setValidationError] = React.useState(null);
    const searchItems = () => {
        setValidationError(null);
        setSearchArgs({
            query,
        });
    };
    const { getCheckbox, checkedItems } = useCheckboxes({
        externallyCheckedItems: selectedLmsIntegrations || [],
        equalsFunc: (a, b) => a.id === b.id,
    });
    const { table, dataState } = usePagedSortedTable({
        addCheckboxes: {
            useCheckboxesMakeCheckbox: getCheckbox,
            getCheckedItem: (data, index) => data.data[index],
        },
        getData: (sort, page, sArgs) => __awaiter(void 0, void 0, void 0, function* () {
            return LmsIntegrationService.search({
                query: sArgs.query,
            }, {
                sort: sort === null || sort === void 0 ? void 0 : sort.sort,
                order: sort === null || sort === void 0 ? void 0 : sort.order,
                max: PAGE_SIZE,
                offset: page * PAGE_SIZE,
            });
        }),
        searchArgs,
        getNumPages: (result) => TotalPageMappers.EngagePagedResult(result, PAGE_SIZE),
        noDataComponent: "No Prospect Sources found",
        initialSort: { sort: "PROSPECT_SOURCE_NAME", order: "asc" },
        columns: [
            {
                title: "Id",
                sortId: "LMS_INTEGRATION_ID",
                size: 1,
            },
            {
                title: "Name",
                sortId: "LMS_INTEGRATION_DISPLAY_NAME",
            },
            {
                title: "Description",
                sortId: "LMS_INTEGRATION_DESCRIPTION",
            },
        ],
        rows: (pagedResults) => pagedResults.data.map((lmsIntegration) => [
            lmsIntegration.id,
            lmsIntegration.displayName,
            lmsIntegration.description,
        ]),
    });
    return children({
        selectedItems: checkedItems,
        isLoading: dataState.isLoading,
        totalNumItems: (_a = dataState.data) === null || _a === void 0 ? void 0 : _a.total,
        lookup: (_jsxs(_Fragment, { children: [validationError && _jsx(AlertError, { message: validationError }), _jsxs("div", { className: "mb-3 form-inline", children: [_jsxs("div", { className: "form-group mr-3 mt-2 ", children: [_jsx("label", { htmlFor: "lmsIntegrationSearch", className: "sr-only", children: "Search" }), _jsx("input", { type: "text", className: "form-control", id: "lmsIntegrationSearch", placeholder: "Search Name", style: { width: 200 }, value: query, onChange: (event) => {
                                        setQuery(event.target.value);
                                    }, onKeyPress: (e) => {
                                        if (e.key === "Enter") {
                                            searchItems();
                                        }
                                    } })] }), _jsx("div", { className: "mt-2", children: _jsx(SearchButton, { isLoading: dataState.isLoading, onClick: () => {
                                    searchItems();
                                } }) })] }), _jsx("hr", {}), table] })),
    });
};
export default LmsIntegrationLookup;
